import pic1 from "./images/allFlowers/pansySeedling.jpg"
import pic2 from "./images/allFlowers/primerose1.jpg"
import pic3 from "./images/allFlowers/marigold.jpg"
import pic4 from "./images/allFlowers/snapdragon.jpg"
import pic5 from "./images/allFlowers/geranium.jpg"
import pic6 from "./images/allFlowers/sunflower.jpg"
import pic7 from "./images/allFlowers/begonia.jpg"
import pic8 from "./images/allFlowers/petunia.jpg"
import pic9 from "./images/allFlowers/chrysanthemums.jpg"
import pic10 from "./images/allFlowers/sweetpea.jpg"
import pic11 from "./images/allFlowers/viola.jpg"
import pic12 from "./images/allFlowers/zinnia.jpg"
import pic13 from "./images/perennial/daylily.jpg"
import pic14 from "./images/perennial/peony.jpg"
import pic15 from "./images/allFlowers/shasta.jpg"
import pic16 from "./images/perennial/lavender.jpg"
import pic17 from "./images/allFlowers/lilac.jpg"
import pic18 from "./images/perennial/hibiscus.jpg"
import pic19 from "./images/perennial/hydrangea.jpg"
import pic20 from "./images/perennial/azalea.jpg"
import pic21 from "./images/allFlowers/rhododendron.jpg"
import pic22 from "./images/floweringTree/cherrytree.jpg"
import pic23 from "./images/allFlowers/almondtree.jpg"
import pic24 from "./images/allFlowers/plumtree.jpg"
import pic25 from "./images/allFlowers/crabapple.jpg"
import pic26 from "./images/allFlowers/magnolia.jpg"
import pic27 from "./images/allFlowers/pear.jpg"
import pic28 from "./images/allFlowers/kalachoe.jpg"
import pic29 from "./images/allFlowers/cacti.jpg"
import pic30 from "./images/allFlowers/chrismascactus1.jpg"
import pic31 from "./images/allFlowers/orchids.jpg"
import pic32 from "./images/allFlowers/lily.jpg"
import pic33 from "./images/allFlowers/crocus.jpg"
import pic34 from "./images/allFlowers/tulips.jpg"
import pic35 from "./images/allFlowers/daffodils.jpg"
import pic36 from "./images/allFlowers/dahlia.jpg"
import pic37 from "./images/allFlowers/snowdrop.jpg"
import pic38 from "./images/allFlowers/bluebell.jpg"
import pic39 from "./images/allFlowers/iris.jpg"
import pic40 from "./images/allFlowers/alium.jpg"





let annualFlowers = [

//     Annuals are a type of plants that grow from seed to bloom and then die in one season. This means that you need to plant annual flowers every year to enjoy their gorgeous colors.
// There are some perennial flowers that are grown as annuals as they don’t survive the cold winter. So in warmer zones they are planted as perennials, however in cooler zones they are grown as annuals. You can bring them indoors during winter, and then replant them outdoors in spring.
// Some annuals flower well in cooler temperatures and may bloom in early spring or even in late winter. Here are a few varieties of annuals that blossom in springtime.


    // Annual Flowers that Bloom in the Spring

    {
        id: 1,
        src: <img src={pic1} alt=''/>, 
        title: 'Pansies',
        header: "Pansies are beautiful flowers that come in a wide array of colors",
        description: 'Pansies are one of the most popular early bloomers that produce beautiful flowers with large petals in many colors. Although pansies are perennial flowers, they usually die back in cold winters because they are not hardy plants in cold winters. Some common types of pansy flowers have stunning 3-color petals in deep blues, yellows, reds, and purple. There are also some types of pansy flowers that are black. Pansies grow best in full sun and planted in well-drained soil and they add beautiful color to your garden.'
      
    },
    {
      id: 2,
      src: <img src={pic2} alt=''/>,
      title: "Primerose",
      header: "There is a wide variety of beautiful primrose flowers to suit any color scheme in your garden",
      description: "Bright primerose flowers, plant shoots with green leaves and plant essences or organic extracts in flasks and test tubes. Natural ingredients use for alternative medicine, healthy cosmetics concept.Primrose is another well-loved variety of flowering plant due to its bright yellow, red, or purple petals it produces in early spring. Although there are types of perennial primrose flowers, many gardeners grow primrose as annual plants. Primrose plants commonly grow in the wild in forests, near beaches, and wasteland. They also make great container flowering plants to brighten up a deck area or balcony area. Gorgeous primrose flowers have small petals that usually have a bright yellow center. Plant primrose flowers in an area of your garden that gets some sun but also plenty of shade. Most primrose varieties enjoy moist soil; however, some types of primroses thrive well in dry, well-drained soil. There are a number of other varieties of flowers that bloom in early spring such as daffodils, tulips, and crocuses",
    },

    // Types of Annual Flowers that Bloom in Summer (With Pictures)
    // Because most annual plants that flower are planted in springtime, you can expect beautiful blossoms in the summertime.
    
    {
      id: 3,
      src: <img src={pic3} alt=''/>,
      title: "Marigolds",
      header: 'Dried Marigold flowers in a wooden bowl, herbal tea, alternative medicine.',
      description: "Marigold is one of the most popular and famous type of annual flower that can be found in many gardens. Appreciated around the world for their beautiful flowers, marigolds are a type of flowering plant from the Calendula genius. Common marigold flowers are generally large flowers with bright yellow or orange-colored petals and the flower head has a dark center. The incredibly beautiful flower head is made up of tiny petals that can have about 6 or 7 layers. Marigolds bloom in the summertime and can continue flowering until early fall. The famous marigold flowers are a perfect type of garden flower because they add great color",
    },
    {
      id: 4,
      src: <img src={pic4} alt=''/>,
      title: "Snapdragon flowers",
      header: 'Colourful snapdragon flowers in a garden',
      description: "Snapdragons can come in color combinations. Appreciated around the world for their beautiful flowers, snapdragons are grown as a type of annual plant even though they are categorized as a perennial plant. The reason for this is that they are not cold hardy and they don’t survive cold winters very well. When snapdragons bloom in summer, they create a sea of multi-colored flowers in the garden. Snapdragon plants grow long leafy stems that are crowned with conical-shaped bright flowers. To enjoy these annual flowers that come in a wide variety of colors, plant them in full sun and in well-drained soil. Snapdragons are perfect garden flowers as they are very colorful. ",
    },
    {
      id: 5,
      src: <img src={pic5} alt=''/>,
      title: 'Geranium flowers',
      header: "A hot pink geranium blossom on a plant in a greenhouse on Cape Cod",
      description: "Geraniums are a very popular type of summer-blooming plant due to its multitude of varieties.Geraniums can grow as perennial flowers in warmer climates and enhance any landscaped garden. Although most geraniums are grown as annuals, in warmer zones they are grown as perennial flowers. The most common colors of petals for geranium flowers are red, orange, purple, white, and pink. Geranium flowers are made up of 5 long petals that have veins running through them. For some avid gardeners, geraniums are the most popular flowers to grow in the garden as they thrive in most types of soil. You can enjoy the beautiful blooms of geranium flowers from summer to early fall. There are also some types of geranium that bloom in late spring.",
    },

    {
        id: 6,
        src: <img src={pic6} alt=''/>,
        title: 'Sunflower',
        header: "Lone sunflower on the background of the wheat field.",
        description: "Sunflower is a type of annual flower that looks stunning in any garden. One of the tallest flowering annual plants is the sunflower. These famous flowers are easily identified with their long stems and very large big round yellow flowers. Sunflowers bloom at their peak in the middle of summer. They usually start flowering in the middle of summer and can continue blooming until the fall. If you have areas of your garden that get all-day sun, you can plant sunflowers there as a stunning backdrop for your bushes or flower beds. Sunflowers are grown commercially for their oil and their seeds.",
      },


    //   Types of Annual Flowers: Plants that Flower in the Fall 
    // It can be difficult to categorize plants that specifically bloom in the fall due to the fact that many summer flowers continue blooming through the fall.
    // Begonia and petunia are beautiful flowers that bloom during autumn

    {
      id: 7,
      src: <img src={pic7} alt=''/>,
      title: "Begonia flowers",
      header: "Close-up of flowering plants being grown at a Coastal California nursery.",
      description: "Begonias are decorative flowers that don’t survive the winter well. Extremely popular worldwide, begonias are a type of annual flowering plant that will continue to flower into the fall. The beauty of begonias is that they can provide pretty flowers throughout all of the growing seasons. Most gardeners plant begonia flowers in their garden as annuals and not perennials as they don’t survive the winter well. Begonias have become one of the most popular flowering plant varieties due to their showy display of flowers and attractive leaves. Plant begonias in partial shade and well-drained soil to enjoy maximum blooming time from these delightful flowering plants."
    },

    {
      id: 8,
      src: <img src={pic8} alt=''/>,
      title: "Petunia flowers",
      header: "Blooming petunias and hummingbird on the background",
      description: "Petunias are an autumn or fall flower that produces mainly pink, white, and violet blossoms. Having petunias in your garden will give it plenty of color in the fall when some other types of annuals have stopped flowering. Petunias are described as half-hardy annuals as most varieties don’t survive harsh frosts. Their attractive flowers grow in the shape of a funnel and come in light pink, dark purple, lilac, and crimson colors. Some of the most beautiful petunia flowers have multicolored petals shaped like a trumpet with dark, almost black centers. Some other common types of petunia flowers have small round petals with light-colored stripes originating from the center."
    },

    {
      id: 9,
      src: <img src={pic9} alt=''/>,
      title: "Chrysanthemum flowers",
      header: "Red Chrysanthemum flower on white background",
      description: "Chrysanthemum is an extremely popular outdoor flower because it adds color to your garden. Chrysanthemums (or, sometimes called mums) are a type of flowering plant that produces large colorful blooms in the fall. The beautiful flower heads of chrysanthemums consist of long petals that form a large flower. Some popular types of chrysanthemum flowers can be ball-shaped, globe-shaped, or star-shaped. Hybrids of chrysanthemums can come in a wide variety of colors including bright orange, red, pink, green, and white. Chrysanthemums will give you plenty of delightful blooms in the fall that also make great cut flowers for your home."
    },

    // Types of Annual Flowers: Plants that Flower in Winter
    // Let’s look at some of the flowering annual plants that give your garden or home a dash of color during winter months.

    {
        id: 10,
        src: <img src={pic10} alt=''/>,
        title: "Sweet pea",
        header: "Display basket of summer garden Sweet Pea flowers",
        description: "Sweet pea is an annual climbing flowering vine that thrives in full sun. They are a type of flowering climbing plant that you need to plant every year to enjoy their dainty flowers. One of the reasons why sweet peas have become a popular winter flower is that they have a delightful fragrant aroma. The wafer-thin petals on the flowers are usually delicate shades of pinks, purples, and whites. Plant sweet peas in your garden where they can get plenty of sun and in well-drained soil. Furthermore, sweet peas also flower at other times of the year."
      },

      {
        id: 11,
        src: <img src={pic11} alt=''/>,
        title: "Winter Viola flowers",
        header: "Violas flower throughout fall and winter and display a stunning array of color",
        description: "Viola is a flowering plant in the violet family Violaceae. They are perennials, but they are usually treated as annuals, invaluable for fall, winter and spring. Violas are heart-shaped or kidney-shaped and their colors include yellow, orange, blue, scarlet, white and violet, or multi-colored. Plant violas in the fall if you want them to flower on and off during the winter months. Winter violas are tough enough to survive cold weather and can flower all through the winter. Winter violas have small flowers that come in many color combinations so they will brighten your garden during winter time."
      },

      {
        id: 12,
        src: <img src={pic12} alt=''/>,
        title: "Annual Zinnia Flowers",
        header: "Gentle salmon colored zinnia flower close up on green leaves background",
        description: "Delicate cactus zinnia with needle-shaped, acicular petals. Floriculture, gardening or landscaping concept. Zinnia produces vibrant flowers that look beautiful in bouquets."
      }


      

  
  
  

  ];
  
  export function getAnnualFlowers() {
    return annualFlowers;
  }

  export  function getData(identify) {
    return(
      annualFlowers.find( annualFlower => annualFlower.id === identify)
    )
  }

  
// Types of Perennial Flowers
// Perennials are a type of flowering plant that grows year after year. That means that you don’t have to plant perennial flowering plants if you want to enjoy their blooms every year.

// Though perennials should last for years, not all of them grow year after year. Some perennials are tender and they die in winter. They are called annuals if you live in a place with a cold winter. Only hardy perennial flowers survive the winter and come back year after year.

// Bulbs are also a type of perennial flower; however, flowering bulbs are listed as a separate category of flowering plants.

// Roses are very popular perennial flowers that include many species and cultivars
let perennialFlowers = [
    {
        id: 13,
        src: <img src={pic13} alt=''/>, 
        title: 'Daylily',
        header: "Daylily is a perennial tall flowering plant with attractive showy blooms",
        description: 'Extremely popular worldwide, daylilies produce mainly yellow or orange flowers that come back every year. However you can actually get exceptional daylilies flowers in many other colors including pink, purple and red.Planting daylilies is popular with gardeners as the long-stemmed flowering plants grow in most conditions. The star-shaped beautiful flower has long leaves that turn back on themselves and have a protruding stamen. In some ways, daylilies (Hemerocallis) look like flowers from traditional lilies (Lilium).'
      
    },
    {
      id: 14,
      src: <img src={pic14} alt=''/>,
      title: "Peony flowers",
      header: "Peonies are one of the most beautiful flowers and they have great scent",
      description: "Peony is a type of flowering shrub-like plant that produce stunning large puffy flowers that have a wonderful fragrance.The large peony flowers are usually a light pink, dark pink or white color. Due to the fact that this popular flower has lots of petals, they look like a fluffy ball. The plant blooms year after year in the late spring or early summer. However, the peony plant only blooms for 7 -10 days every year. Due to their striking appearance, peonies often make great cut flowers for large bouquets or fancy ornamental flowers.In fact, some wedding bouquets that include peonies can cost hundreds of dollars.",
    },
    {
      id: 15,
      src: <img src={pic15} alt=''/>,
      title: "Shasta daisy",
      header: 'Shasta daisy is an early blooming flower',
      description: "This early bloomer, the Shasta daisy produces small white flowers with a yellow center every year.The daisy flowers sit on top of long stems and the stems usually grow in clusters. These extremely beautiful perennial flowers that bloom every spring may even last throughout the summer if you cut them back properly.",
    },

    // Types of Popular Flowering Shrubs and Bushes
    // Most types of shrubs and bushes produce blooms every year. Some types of perennial bushes can even grow to the size of a small tree, whereas others are small shrubs that are only knee-height or smaller.
    
    {
      id: 16,
      src: <img src={pic16} alt=''/>,
      title: "Lavender",
      header: 'Lavender is a type of perennial flowering plant with purple fragrant flowers',
      description: "Flowering lavender shrubs are one of the most popular small flowering shrubs due to their beautiful light-blue flowers and fragrant aromas.Lavender is generally a hardy shrub that can grow in dry sandy soil and withstand full sun. Lavender flowers consist of tiny petals that grow up the stem. These long lavender blooms can start flowering from early spring, and some varieties can last until the end of the summer. When it comes to medicinal flowering plants, lavender usually tops the list. The essential oil of lavender is prized for its antibacterial and soothing properties. ",
    },
    {
      id: 17,
      src: <img src={pic17} alt=''/>,
      title: 'Lilac bush',
      header: "Lilac bush is a type of flowering plant",
      description: "Lilac is a large type of flowering bush that produces large conical flowers made up of tiny petals. Lilac bushes come in various sizes with the dwarf bush growing about 4 ft. (1.2 m) tall and large bushes growing to about 20 ft. (6 m). Lilac bushes don’t bloom for a very long time. But they produce a large number of elegant flowers every year late in the spring or early summer. The most common color of lilac flowers is light purple. However, there are also types of lilac that produce white, burgundy, yellow, or pink colored flowers.",
    },

    {
        id: 18,
        src: <img src={pic18} alt=''/>,
        title: 'Hibiscus flowers',
        header: "Hibiscus is a type of flowering bush",
        description: "Hibiscus plants produce large stunning flowers with thin delicate petals that come in a variety of colors. The two main types of hibiscus flowers are single-bloom flowers and double-bloom flowers. Single blooms of the hibiscus resemble a trumpet with a long stamen protruding. Double bloom hibiscus shrubs have a crepe-like paper appearance and a bushy head. The hibiscus is considered to be a complete flower because it contains the four main parts of a flower: petals, sepals, stamen, and carpel. A popular type of hibiscus is the rose of Sharon.",
      },

      //Other types of flowering shrubs that annually produce flowers 

    {
      id: 19,
      src: <img src={pic19} alt=''/>,
      title: "Hydrangea",
      header: "Pressed and dried dry flower hydrangea isolated on white background",
      description: "Hydrangeas have big showy flowers that can grow as low hedges, foundation plants, accent plants, or container plantings Hydrangea bushes bloom yearly from early spring to late fall. The large showy globe flowers sit at the end of a stem."
    },

    {
      id: 20,
      src: <img src={pic20} alt=''/>,
      title: "Azalea flowers",
      header: "Azalea flowers isolated",
      description: "Azalea flowers are stunning to look at, and the bush adds light bright colorful flowers when it blooms every spring. Azalea flowers are often used in wedding bouquets due to their beautiful appearance."
    },

    {
      id: 21,
      src: <img src={pic21} alt=''/>,
      title: "Rhododendron",
      header: "Pink blossom of rhododendron with green leaves over a white background",
      description: "Rhododendron is a large bush that produces clusters of large flowers. This type of bush is often used in hedgerows where they produce amazing blooms from early spring to the middle of summer."
    },

    {
      id: 40,
      src: <img src={pic40} alt=''/>,
      title: "Alium",
      header: "Close-up picture of Purple alium onion flower in full frame isolated on white background with copy space.",
      description: "Allium is a genus of monocotyledonous flowering plants that includes hundreds of species, including the cultivated onion, garlic, scallion, shallot, leek, and chives. The generic name Allium is the Latin word for garlic, and the type species for the genus is Allium sativum which means cultivated garlic"
    },
  ];
  
  export function getPerennialFlowers() {
    return perennialFlowers;
  }

  export  function getInfo(select) {
    return(
      perennialFlowers.find( perennialFlower => perennialFlower.id === select)
    )
  }

  // Flowering trees
  // Types of flowering trees
  // The beauty of flowering trees can enhance any garden or park and also provide an abundance of fruit at the end of the summer.

  let floweringTrees = [
    {
        id: 22,
        src: <img src={pic22} alt=''/>, 
        title: 'Cherry blossom trees',
        header: "Flowering tree of Japanese sakura in spring",
        description: 'Flowering cherry trees are one of the most stunning flowering trees you could have in your garden. Every March or April, cherry blossom trees change into striking pinks and whites when they blossom. In addition to that, their foliage also turns to spectacular colors in the fall. Parks that contain a large number of cherry trees attract many tourists every year to admire their amazing blossoms. Cherry blossom trees produce inedible small cherries.'
      
    },
    {
      id: 23,
      src: <img src={pic23} alt=''/>,
      title: "Flowering almond tree",
      header: "Big white almond tree in the field",
      description: "The almond tree also tops the list of the most beautiful blossoming trees. Although technically a type of flowering shrub, most gardeners grow almond shrubs as trees. Pink or white blossoms adorn the flowering tree every spring.",
    },
    {
      id: 24,
      src: <img src={pic24} alt=''/>,
      title: "Plum tree flowers",
      header: 'Pink flower, Cherry blossoms tree isolated on white background.',
      description: "Flowering plum trees are yet another example of a tree that transforms gardens from green into colorful shades of pink, purples, and white. The plum tree is one of the best trees to plant in your garden for extra color. Not only does the tree bloom every spring, but the leaves also turn a deep burgundy color. At the end of the summer purple sweet plums are ready for harvesting.",
    },

    // Other beautiful types of flowering trees

    {
      id: 25,
      src: <img src={pic25} alt=''/>,
      title: "Flowering crabapple tree",
      header: 'white crab apple flowers in the springtime',
      description: "Flowering crabapple tree brings many people to New York when the delightful trees start to flower every year from mid-April to May.",
    },
    {
      id: 26,
      src: <img src={pic26} alt=''/>,
      title: 'Magnolia flower',
      header: "Purple magnolia flower, Magnolia felix isolated on white background, with clipping path",
      description: "Magnolias are beautiful flowering trees or shrubs with stunning pink, purple, yellow, or white flowers. Magnolia trees and shrubs have thick leathery leaves and impressive flowers that appear early in the spring. Magnolias can be deciduous or evergreen depending on their growing zone.",
    },

    {
        id: 27,
        src: <img src={pic27} alt=''/>,
        title: 'The flowering pear tree',
        header: "Twig of pear blossom on white background",
        description: "The flowering pear tree, like most fruit trees, produces stunning blooms in the springtime. The blooms of the pear tree are so white and vibrant that the tree looks like it’s covered in snow.",
      },

      // Flowering Succulent Plants
// Succulents are a type of plant that has thick fleshy leaves and it grows in dry, hot climates. Succulents come in all shapes and sizes and have a wide range of different types of flowers. While succulent plants have the ability to bloom, the location and conditions need to be right for them to do so.
    {
      id: 28,
      src: <img src={pic28} alt=''/>,
      title: "Kalanchoe ",
      header: "Red Kalanchoe flowers on a wooden background.",
      description: "Kalanchoe is a type of tropical succulent that produces small flowers that come in clusters. The flowers on the kalanchoe are long-lasting and came in various shades of orange, pink, yellow, red, and white. These small flowers look striking in contrast to the shiny green leaves."
    },

    {
      id: 29,
      src: <img src={pic29} alt=''/>,
      title: "Cacti",
      header: "Cacti on a white background.",
      description: "Cacti are similar to succulents in that they grow in hot, dry climates. Every type of cacti is a flowering plant; however, the ability of the cactus to produce flowers depends greatly on its environment"
    },

    {
      id: 30,
      src: <img src={pic30} alt=''/>,
      title: "Christmas cactus",
      header: "Christmas cactus (Schlumbergera) in pot",
      description: "The Christmas cactus is a type of blooming plant that flowers around the end of the year. This perennial flowering plant has long hanging leaves that are glossy and green. All types of “holiday” cactus have the potential to produce white, red, pink, or purple flowers every year. Some types of cacti bloom for several weeks every year."
    },

//     Orchids – Tropical Types of Flowers for the Home
// Orchids produce some of the most stunning and delicate flowers from any type of flowering plant. There are actually hundreds of varieties of orchid plants that produce tropical flowers in a wide range of colors. You really have to see pictures of flowering orchids to believe all the varieties of petal shapes and colors.
// Let’s look at one of the most popular types of orchids that is easy to grow at home

    {
      id: 31,
      src: <img src={pic31} alt=''/>,
      title: "Phalaenopsis flowering orchid",
      header: "Stylish interior design with beautiful white potted orchid flowers and bookcase next to window",
      description: "The Phalaenopsis orchid (or, moth orchid) is one of the easiest orchids to care for at home. Even with the Phalaenopsis orchid, there are around 70 different species – all with different types of stunning exotic flowers and colors!n The Phalaenopsis plant produces stems that contain multiple elegant flowers on each one. Some types of these extremely popular orchid flowers have plain white petals with a burgundy center. Other varieties of gorgeous flowers have stunning red leaves with white or yellow stripes or multicolored leaves that seem to gently fade to other colors."
    },

    // Flowering bulbs
    // Flowering bulbs are one of the most popular types of flowering plants that grow and bloom every year.


    {
      id: 32,
      src: <img src={pic32} alt=''/>,
      title: "Lilies",
      header: "Lilies isolated on a whilte background.",
      description: "Lilies are flowering bulbs that produce some of the most stunning and striking flowers of any plant. Lilies, especially white ones, are also a popular type of wedding flower. In fact, some varieties of lilies are very expensive wedding flowers."
    },

    {
      id: 33,
      src: <img src={pic33} alt=''/>,
      title: "Crocus flowers",
      header: "Blue Crocus on a white background.",
      description: "When crocuses bloom every year, it is a sign that spring has arrived. Although crocus flowers come in almost every color, yellow, lilac, and mauve are the most common flowers. There are a wide variety of crocus petals. Some have just one color, whereas others have stripes or multicolored petals"
    },

    {
      id: 34,
      src: <img src={pic34} alt=''/>,
      title: "Tulips",
      header: "Bouquet of red tulips isolated on white background",
      description: "Extremely popular worldwide, tulips are the classic spring flower that have an amazing array of bright, vibrant colors.These flowering bulb varieties of plants have relatively large elegant flower sitting on top of a green stem. There are a reported 15 different types of tulip flower shapes. Some are the typical oval shape of a tulip petal, others have lily-shaped petal, and some have wispy multicolored petals that have a puffy appearance. Tulips flower from year to year and like to grow in full sun and well-drained soil."
    },

    {
      id: 35,
      src: <img src={pic35} alt=''/>,
      title: "Daffodils ",
      header: "bouquet of yellow daffodils in a glass vase and a retro cup on the table, a sunny rustic composition.",
      description: "Daffodils are another type of popular flower worldwide that blooms in the spring and produces flowers that come back every year. The most common daffodil is a yellow flower with 6 petals in a star-shape and protruding tubular petal in the center. Other types of daffodil flowers are an array of white petals with a yellow or orange trumpet-type petal in the center. Some showy daffodils have multiple layers of petals in the center that form a bouquet of petals."
    },

    {
      id: 36,
      src: <img src={pic36} alt=''/>,
      title: "Dahlia flowers",
      header: "Close up of a huge creme blooming Dahlia flower Cafe au Lait Hybrid.",
      description: "Dahlia plants produce stunning colorful flowers usually in the shape of a ball or star on top of a leafy stem.  Dahlia flowers come in most colors including yellow, white, red, pink, lavender, and even dark burgundy which is nearly black. Some popular dahlia flowers have flower heads in many fascinating color combinations."
    },

    // Other types of flowering bulbs

    {
      id: 37,
      src: <img src={pic37} alt=''/>,
      title: "Snowdrops",
      header: "Beautifull Spring snowdrop flowers on snow background",
      description: "Snowdrops are tiny flowers that have a white bell-shaped flower that hangs down. They are usually one of the first flowers to bloom after winter."
    },

    {
      id: 38,
      src: <img src={pic38} alt=''/>,
      title: "Bluebells",
      header: "Bluebells isolated on white.",
      description: "Bluebells are another example of an early bloomer bulb flower that grows in the wild. They produce pretty blue or lilac flowers that look like tiny bells dangling from stems."
    },

    {
      id: 39,
      src: <img src={pic39} alt=''/>,
      title: "Iris",
      header: "Closeup image of a Iris reticulata against a white background",
      description: "Iris is a type of perennial flowering bulb that grows long erect stems with a large flower at the end. Iris plants can start blooming as early as February or March. Some varieties of iris called the Black Iris also produce black flowers."
    },

    // {
    //   id: 40,
    //   src: <img src={pic40} alt=''/>,
    //   title: "Alium",
    //   header: "Close-up picture of Purple alium onion flower in full frame isolated on white background with copy space.",
    //   description: "Iris is a type of perennial flowering bulb that grows long erect stems with a large flower at the end. Iris plants can start blooming as early as February or March. Some varieties of iris called the Black Iris also produce black flowers."
    // },

  ];
  
  export function getFloweringTrees() {
    return floweringTrees;
  }

  export  function getMore(more) {
    return(
      floweringTrees.find( perennialFlower => perennialFlower.id === more)
    )
  }